export class Router {
    constructor(routes, options = {}) {
        this.routes = routes;
        this.options = options;
    }
    start() {
        addEventListener('hashchange', () => this.resolve());
        if (!location.hash)
            location.hash = '#/login';
        this.resolve();
    }
    async resolve() {
        const guarded = this.options.guard ? this.options.guard(location.hash) : location.hash;
        if (guarded !== location.hash) {
            location.hash = guarded;
            return;
        }
        const match = this.routes.find(r => r.path === guarded);
        const mount = document.getElementById('app');
        mount.innerHTML = '';
        if (!match)
            return;
        const mod = await match.component();
        // Il default pu� restituire: (a) una funzione factory (root)=>void
        //                           (b) un HTMLElement/Node gi� pronto
        const res = await (mod?.default?.());
        if (typeof res === 'function') {
            // factory: monta dentro 'mount'
            res(mount);
        }
        else if (res instanceof Node) {
            // nodo DOM pronto
            mount.appendChild(res);
        }
        else if (res && typeof res === 'object' && 'mount' in res && typeof res.mount === 'function') {
            // eventuale API { mount(root) { ... } }
            res.mount(mount);
        }
        else {
            console.error('Il modulo deve esportare default() che ritorna una funzione (root)=>void oppure un HTMLElement. Ricevuto:', res);
        }
    }
}
